import dayjs from "dayjs";
import "dayjs/locale/en";
dayjs.locale("en");

export const isUnderage = (birthday: dayjs.Dayjs, minimumAge = 18): boolean => {
  const today = dayjs();
  const minimumBirthdate = today.subtract(minimumAge, "years").endOf("day");
  return birthday.isAfter(minimumBirthdate);
};

export const getInitialSocialMediaListValues = ({ addonBefore, value }) => {
  if (!Array.isArray(value) || !Array.isArray(addonBefore)) return {};

  return addonBefore.reduce((acc, platform, index) => {
    if (value[index]) {
      acc[platform] = value[index];
    }
    return acc;
  }, {} as Record<string, string>);
};
